// SYSTEM LENSES — the rows the app SHIPS with (GLOBAL_LENS_PLAN.md §1).
// One definition consumed by the graph's and feed's lensRows and the map's
// preset row injection, so the three pages can never disagree about what the
// built-in lenses are.
//
// GLOBAL is a STATIC synthetic lens: applying it writes GLOBAL_CORE through
// the page's ordinary applyLens — no server resolution, no echo, no
// trending-mode. Empty sets are the lens vocabulary's "unfiltered", so
// Global means "everything, in a 24h window" (birr's §Decision 1: start at
// 24h; event types and regions are all). The server accepts the new kind
// as-is — v2/lens.py:144: "kind is capped, not enumerated".

export const TRENDING_LENS_ROW = {
  id: "trending",
  name: "Trending",
  icon: "zap",
  color: "#0EA5E9",
  dynamic: true,
  fixed: true,
};

export const GLOBAL_LENS_ROW = {
  id: "global",
  name: "Global",
  icon: "globe",
  color: "#0EA5E9",
  fixed: true,
};

// Trending first (birr's §Decision 2).
export const SYSTEM_LENS_ROWS = [TRENDING_LENS_ROW, GLOBAL_LENS_ROW];

export const GLOBAL_PRESET_REF = { kind: "global", id: null };

// The core applyLens(GLOBAL_CORE, null) applies on graph/feed; the map
// passes the same shape through applyMapPresetState (empty lists clear its
// dialect selections the same way).
export const GLOBAL_CORE = {
  eventTypes: [],
  regions: [],
  timeRange: "24h",
  customDateRange: null,
};

// presetProps.activePresetId derivation shared by graph/feed: system kinds
// highlight their own row; everything else highlights by id.
export const activePresetRowId = (activePreset) => {
  if (activePreset?.kind === "trending") return "trending";
  if (activePreset?.kind === "global") return "global";
  return activePreset?.id;
};
